import type { ClientOrganization } from '@DigitaleDoerfer/digitale-doerfer-api';

import { territorialAuthorityExtensionWithSections } from '@/features/profile-setting/components/organization-extensions/territorial-authority/sections';
import type {
  OrganizationExtension,
  OrganizationTag
} from '@/features/profile-setting/components/organization-extensions/types';

const EXTENSIONS_WITH_SECTIONS: OrganizationExtension[] = [
  territorialAuthorityExtensionWithSections
];

export const getActiveExtensionSections = (
  tags: OrganizationTag[]
): OrganizationExtension[] =>
  EXTENSIONS_WITH_SECTIONS.filter((ext) => tags.includes(ext.tag));

export const getActiveExtensionSectionsForOrganization = (
  organization: ClientOrganization
): OrganizationExtension[] =>
  getActiveExtensionSections(organization.tags ?? []);
